<template>
  <div class="flex-grow flex flex-col overflow-hidden">
    <div
      :class="classList"
      class="grow-0 shrink-0"
    >
      <slot name="labels" />
    </div>
    <div
      v-if="hasContent"
      data-content
      class="flex-grow overflow-hidden relative"
    >
      <slot name="content" />
    </div>
  </div>
</template>

<script>
/**
 * Tabs.vue
 */
export default {
  data () {
    return {}
  },

  computed: {
    classList () {
      return [
        'flex flex-nowrap border-b overflow-auto w-full bg-white',
      ]
    },

    hasContent () {
      return !!this.$slots.content
    },
  },
}
</script>
